@if (showEnkashToolbar) {
  <app-enkash-toolbar [isSdebarAllowed]="sidebarEnabled" [displaySetting]="isSettingButtonHidden" [displayLogo]="isHeaderImageHidden" [callingCompanyDetails]="callingCompanyDetails"
    (changingAccountEmitter)="onChangingAccount($event)"
    [pushNotificationArray]="pushNotificationArray"
    [unReadNotificationCount]="unReadNotificationCount"
    [switchCompanyArray]="switchCompanyArray" [switchCompanySelected]="switchCompanySelected"
    [UserRolesArray]="UserRolesArray" [userRoleSelected]="userRoleSelected"
    (changinRoleEmitter)="onChangingRole($event)">
  </app-enkash-toolbar>
}

<div class="d-flex site-container" [ngClass]="{'site-container--full-height': isCobrandedTncRoute()}">
  <!-- side nav -->
  @if (isSdebarAllowed) {
    <div class="enkash-side-nav-container">
      <!-- <app-side-nav></app-side-nav> -->
      <app-side-nav-v2></app-side-nav-v2>
    </div>
  }

  <!-- main content -->
  <div class="enkash-content-container" #contentDiv infinite-scroll [infiniteScrollDistance]="2" [ngClass]="{'axis-bbps-required': isAxisBBPSuser(), 'enkash-content-container--full-height': isCobrandedTncRoute()}"
    [infiniteScrollThrottle]="50" (scrolled)="bruu()" [scrollWindow]="false">
    <router-outlet (activate)="scrollToTop($event);"></router-outlet>
  </div>
</div>
<!-- <app-product-guide></app-product-guide> -->

<ng-template #childModal>

  <div class="modal-container mx-auto p-5">
    <div class="modal-header">
      <p class="modal-title" id="modal-basic-title">Your session is about to expire!</p>


      <p class="modal-description">
        For security reasons, you will be logged out due to inactivity for more than 15 minutes.
      </p>
      <p class="modal-sub-description mt-3">
        Do you want to continue working?
      </p>

    </div>


    <div class="modal-footer">

      <button mat-flat-button color="accent" class="custom-button me-3" (click)="logout()">
        No, Logout
      </button>

      <button mat-flat-button color="primary" class="custom-button" (click)="stay()">
        Yes, Keep Working
      </button>
    </div>
  </div>
</ng-template>

<app-export-banner />
